module.exports = __webpack_public_path__ + "img/hk_hhk.ab9ebbb1.png";